export default {
    // 数据
    openid: localStorage.getItem('openId') ? JSON.parse(localStorage.getItem('openId')) : null,
    initData: localStorage.getItem('initData') ? JSON.parse(localStorage.getItem('initData')) : {}
}